import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { Panel_MultiVarValList } from '../panels/Panel_MultiVarValList/Panel_MultiVarValList.js';
import { Panel_DiseaseValueList } from '../panels/Panel_DiseaseValueList/Panel_DiseaseValueList.js';
import { PanelHeader } from '@app/hcs-frontend';
export class DPView_VariablesAndValues extends ComponentSync {
    workspaceKey = 'disease-profile-likelihood';
    likelihoodRenderer = {
        horizontalSpace: TS_HorizontalWorkspace,
        likelihoodVariables: Panel_MultiVarValList,
        likelihoodValues: Panel_DiseaseValueList,
    };
    // ######################### Static #########################
    deriveStateFromProps(nextProps) {
        return {
            diseaseView: nextProps.diseaseView,
        };
    }
    shouldComponentUpdate(nextProps) {
        return true;
    }
    render() {
        return _jsxs(LL_V_L, { className: "disease-profile-data-renderer", children: [_jsx(PanelHeader, { title: this.state.diseaseView.label || 'No Property Selected' }), _jsx(TS_Workspace, { renderers: this.likelihoodRenderer, workspaceKey: this.workspaceKey })] });
    }
}
//# sourceMappingURL=DPView_VariablesAndValues.js.map